import { OpenNewTabTargetType } from '@voltmoney/types';
import { ROUTE } from '../../routes';
import { api, StoreKey } from '../../configs/api';
import { getAppHeader } from '../../configs/config';
import AsyncStorage from "@react-native-async-storage/async-storage";
import { getParameters, getParametersFromURL, getParamsLink, isIframe } from "../../configs/utils";
import { AppLink, CONTEXT, QUERY_PARAMS } from "../../configs/constants";
import { domainCheck, getIframeParentDomain, removeQueryParams } from './utils';
import { Platform } from "react-native";
export const RedirectAction = async (action, _datastore, { navigate, asyncStorage, network, openNewTab, instrumentTrack, initializeAmplitudeWithDeviceID, initializeAmplitude, }) => {
    await AsyncStorage.removeItem("application_id");
    const url = window.location.href;
    const params = getParameters(window.location.href);
    const short_token = params?.t;
    const isCheckLimitMFC = params?.isCheckLimitMFC ? true : false;
    const leadToken = params?.leadtoken;
    const trackingId = params?.trackingId;
    const pljTK = params[QUERY_PARAMS.PLJ_SHORT_TOKEN];
    const digio_autopay_response = params?.digio_autopay_response;
    const parentDomain = getIframeParentDomain();
    await initializeAmplitude('', trackingId);
    let _url2 = removeQueryParams(url, ['t', 'plj']);
    const platform = params?.platform;
    if (platform === 'PHONEPE') {
        _url2 += '&showHome=false';
    }
    if (isCheckLimitMFC && leadToken) {
        await asyncStorage.set(StoreKey.LEAD_TOKEN, leadToken);
        await asyncStorage.set(StoreKey.CONTEXT, CONTEXT.VIEW_DETAIL);
        await navigate(ROUTE.CHECK_LIMIT_MFC_INIT, { isCheckLimitMFC });
    }
    else if (short_token) {
        const headers = { ...(await getAppHeader()) };
        headers.Authorization = `Bearer ${short_token}`;
        const _params = getParametersFromURL();
        const platform = _params?.[QUERY_PARAMS.PLATFORM];
        const utm_source = _params?.[QUERY_PARAMS.UTM_SOURCE];
        if (Platform.OS === "web") {
            window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');
        }
        await network
            .post(`${api.refreshToken}`, {}, {
            headers: headers,
        })
            .then(async (res) => {
            if (Platform.OS === "web") {
                window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');
            }
            if (platform) {
                await AsyncStorage.setItem(StoreKey.accessToken, res.data.jwt, () => {
                    openNewTab(`${AppLink}partnerPlatform${getParamsLink(_url2, false, true)}`, OpenNewTabTargetType.self);
                });
            }
            else {
                await AsyncStorage.setItem(StoreKey.accessToken, res.data.jwt, () => {
                    openNewTab(`${AppLink}${getParamsLink(_url2, false, true)}`, OpenNewTabTargetType.self);
                });
            }
        });
    }
    else if (pljTK
        && domainCheck(parentDomain)
        && isIframe()) {
        const headers = { ...(await getAppHeader()) };
        headers.Authorization = `Bearer ${pljTK}`;
        if (Platform.OS === "web") {
            window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');
        }
        await network
            .post(`${api.refreshToken}`, {}, {
            headers: headers,
        })
            .then(async (res) => {
            if (res.status === 200) {
                if (Platform.OS === "web") {
                    window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');
                }
                if (res && res.data && res.data.jwt) {
                    await AsyncStorage.setItem(StoreKey.accessToken, res.data.jwt, () => {
                        navigate(ROUTE.SPLASH_SCREEN, action.payload);
                    });
                }
            }
            else {
                await instrumentTrack("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                    trackingId: trackingId,
                    failedCause: 'Failed to get new short JWT from response'
                });
            }
        });
    }
    else {
        if (Platform.OS === "web") {
            window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_INITIATED`, '*');
        }
        window.addEventListener('message', async function (event) {
            try {
                if (event.data && event.data.hasOwnProperty('jwt')) {
                    // Short-lived token set temporarily. Call for long-lived token.
                    const headers = { ...(await getAppHeader()) };
                    headers.Authorization = `Bearer ${event.data.jwt}`;
                    const response = await network.post(`${api.refreshToken}`, {}, { headers: headers });
                    if (response && response.data && response.data.jwt) {
                        if (Platform.OS === "web") {
                            window.parent.postMessage(`PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_COMPLETED`, '*');
                        }
                        action.payload = {
                            ...action.payload,
                            trackingId: trackingId
                        };
                        await AsyncStorage.setItem(StoreKey.accessToken, response.data.jwt, () => {
                            if (!digio_autopay_response) {
                                navigate(ROUTE.SPLASH_SCREEN, action.payload);
                            }
                        });
                    }
                    else {
                        await instrumentTrack("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                            trackingId: trackingId,
                            failedCause: 'Failed to get new JWT from response'
                        });
                    }
                }
                else {
                    await instrumentTrack("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                        trackingId: trackingId,
                        failedCause: 'Event data does not contain JWT'
                    });
                }
            }
            catch (error) {
                await instrumentTrack("PLJ_SHORT_TOKEN_TO_LONG_TOKEN_GENERATION_FAILED", {
                    trackingId: trackingId,
                    failedCause: 'Error processing message event'
                });
            }
        });
    }
    if (digio_autopay_response) {
        navigate(ROUTE.DIGIO_MANDATE_SIGN);
    }
};
